/**
 * Formatting utilities for display values
 */

/**
 * Convert any value to a displayable string
 */
export function toDisplay(value: unknown, { truncate = 220 }: { truncate?: number } = {}): React.ReactNode {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'string') {
    return value.length > truncate ? value.slice(0, truncate) + '…' : value;
  }
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  try {
    const json = JSON.stringify(value, null, 2);
    return json.length > truncate ? json.slice(0, truncate) + '…' : json;
  } catch {
    return String(value);
  }
}

/**
 * Format ISO timestamp to localized string
 */
export function formatTimestamp(iso?: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return toDisplay(iso) as string;
  return d.toLocaleString();
}

/**
 * Get status-based color
 */
export function statusColor(status?: string): string {
  const s = (status || '').toUpperCase();
  if (s === 'BLOCK') return '#ef4444'; // red-500
  if (s === 'WARN' || s === 'WARNING') return '#f59e0b'; // amber-500
  if (s === 'ALLOW' || s === 'OK') return '#10b981'; // emerald-500
  return '#94a3b8'; // slate-400 default
}
